// Cleared on every successful login/signup (see store/modules/account.ts), so "dismissed"
// only defers the checklist for the current session, not forever.
const ONBOARDING_CHECKLIST_DISMISSED_KEY_PREFIX = "sb_onboarding_checklist_dismissed_";

// Unlike "dismissed", this is never cleared on login — it marks the checklist as
// permanently done so Dashboard can skip the onboarding redirect (and its data fetches)
// for users who already finished, instead of re-checking on every session.
const ONBOARDING_CHECKLIST_COMPLETED_KEY_PREFIX = "sb_onboarding_checklist_completed_";

export function isOnboardingChecklistDismissed(userId: string): boolean {
  if (typeof window === "undefined" || !userId) return false;
  try {
    return (
      window.localStorage.getItem(ONBOARDING_CHECKLIST_DISMISSED_KEY_PREFIX + userId) === "true"
    );
  } catch (error) {
    console.warn("Failed to read onboarding checklist dismissal state:", error);
    return false;
  }
}

export function dismissOnboardingChecklist(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    window.localStorage.setItem(ONBOARDING_CHECKLIST_DISMISSED_KEY_PREFIX + userId, "true");
  } catch (error) {
    console.warn("Failed to persist onboarding checklist dismissal state:", error);
  }
}

export function clearOnboardingChecklistDismissed(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    window.localStorage.removeItem(ONBOARDING_CHECKLIST_DISMISSED_KEY_PREFIX + userId);
  } catch (error) {
    console.warn("Failed to clear onboarding checklist dismissal state:", error);
  }
}

export function isOnboardingChecklistCompleted(userId: string): boolean {
  if (typeof window === "undefined" || !userId) return false;
  try {
    return (
      window.localStorage.getItem(ONBOARDING_CHECKLIST_COMPLETED_KEY_PREFIX + userId) === "true"
    );
  } catch (error) {
    console.warn("Failed to read onboarding checklist completion state:", error);
    return false;
  }
}

export function markOnboardingChecklistCompleted(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    window.localStorage.setItem(ONBOARDING_CHECKLIST_COMPLETED_KEY_PREFIX + userId, "true");
  } catch (error) {
    console.warn("Failed to persist onboarding checklist completion state:", error);
  }
}

// The "watch our YouTube channel" step has no backend signal to check against, so
// clicking through to the channel is the only completion signal we have — recorded
// here, never cleared on login, same as the "completed" flag above.
const ONBOARDING_YOUTUBE_WATCHED_KEY_PREFIX = "sb_onboarding_youtube_watched_";

export function isOnboardingYoutubeWatched(userId: string): boolean {
  if (typeof window === "undefined" || !userId) return false;
  try {
    return window.localStorage.getItem(ONBOARDING_YOUTUBE_WATCHED_KEY_PREFIX + userId) === "true";
  } catch (error) {
    console.warn("Failed to read onboarding YouTube step state:", error);
    return false;
  }
}

export function markOnboardingYoutubeWatched(userId: string): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    window.localStorage.setItem(ONBOARDING_YOUTUBE_WATCHED_KEY_PREFIX + userId, "true");
  } catch (error) {
    console.warn("Failed to persist onboarding YouTube step state:", error);
  }
}
